import { HttpClient, RequestConfig } from "@planzone/services";
import { Dependencies } from "@planzone/core";
import { createHttpWaitSignal } from "./httpWaitSignal";
import { refreshToken } from "./refreshToken";

function createTokenRefresher(session: Dependencies["session"]) {
  return (httpClient: HttpClient): HttpClient => {
    const waitSignal = createHttpWaitSignal();

    return {
      sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
        return new Promise<void>((resolve) =>
          session
            .retrieve()
            .then(({ refreshToken: token, expiresAt }) =>
              waitSignal.isWaiting()
                ? waitSignal.waitForWaitEndSignal(() => resolve())
                : new Date() >= new Date(expiresAt)
                  ? new Promise<void>((resolveRefresh, rejectRefresh) => {
                      waitSignal.sendWaitSignal();

                      refreshToken(httpClient, token)
                        .then(session.start)
                        .then(waitSignal.sendWaitEndSignal)
                        .then(() => resolveRefresh())
                        .catch(() => rejectRefresh());
                    }).then(() => resolve())
                  : resolve(),
            )
            .catch(() => resolve()),
        ).then(() => httpClient.sendHttpRequest<Response>(config));
      },
    };
  };
}

export { createTokenRefresher };
